export const timeUnits: Array<[ string, number ]> = [
  [ 'Y', 1000 * 60 * 60 * 24 * 365 ], // years
  [ 'M', 1000 * 60 * 60 * 24 * 30 ], // months
  [ 'D', 1000 * 60 * 60 * 24 ], // days
  [ 'H', 1000 * 60 * 60 ], // hours
  [ 'm', 1000 * 60 ], // minutes
  [ 's', 1000 ], // seconds
  [ 'S', 1 ] // million seconds
];
